<template>
  <v-container 
    class="py-3"
    fluid
  >
    <base-material-card
      color="primary"
      icon="mdi-alert-outline"
      inline
      class="px-5 py-4 ml-0"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Logs da Aplicação
        </div>
      </template>
      <v-text-field
        v-model="search"
        :class="!exibirAlert ? 'mb-3': ''"
        append-icon="mdi-magnify"
        label="Procurar"
        hide-details
        single-line
      />
      <v-divider v-if="exibirAlert" class="mt-10" />
      <v-alert v-if="exibirAlert" dense outlined type="info" color="blue" class="mb-3 mt-n5 py-0 px-1">
        Essa tabela exibe logs dos últimos <b>3</b> meses. Caso queira
        visualizar todos os registros,
        <a href="javascript:void(0)" @click="$emit('recarregar', true), exibirAlert = false">clique aqui</a>.
      </v-alert>
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :mobile-breakpoint="800"
        no-data-text="Nenhum log da aplaicação disponível"
        :loading="loading"
        loading-text="Carregando..."
      >
        <template v-slot:[`item.level`]="{ item }">
          <tipo-log :tipoLog="item.level" />
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.created`]="{ item }">
          {{ item.created | parseToDateTimeBR }}
        </template>
        <template v-slot:[`item.ip`]="{ item }">
          {{ item.ip }}
        </template>
        <template v-slot:[`item.mensagem`]="{ item }">
          {{ item.mensagem }}
        </template>
      </v-data-table>
   </base-material-card>
  </v-container>
</template>

<script>
export default {

  components: {
    TipoLog: () => import("@/components/logsAplicacao/TipoLog.vue")
  },

  props: {
    items: {
      type: Array,
      required: true
    },
    loading:{
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    search: "",
    headers: [
      {
        text: 'Tipo do Log',
        value: 'level'
      },
      {
        text: 'Usuário',
        value: 'usuario.nome'
      },
      {
        text: 'Data e Hora',
        value: 'created'
      },
      {
        text: 'IP',
        value: 'IP'
      },
      {
        text: 'Mensagem',
        value: 'mensagem'
      }
    ],
    exibirAlert: true
  })
}
</script>
